import { POST } from '@/api'
import { isEqual } from 'lodash'

const initial = {
  name: '',
}

export default {
  namespaced: true,
  state: {
    staff: initial,
    busy: false,
  },
  getters: {
    changed: ({ staff }, _, { staffs }) => !isEqual(staff, staff.id ? staffs.byId[staff.id] : initial),
  },
  mutations: {
    set(state, staff = initial) {
      state.staff = staff
    },
    update(state, detail) {
      state.staff = { ...state.staff, ...detail }
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  actions: {
    async start({ commit, rootState }, id) {
      commit('set', id ? rootState.staffs.byId[id] : initial)
    },

    async save({ commit, state }) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/v2/staff/register', state.staff)

      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
